import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DTBList from './List';
import { DTBLibraryProvider } from './context';
import DTBCreate from './New';
import DTBDetail from './Detail';
import { AppContext } from 'views/App/context';
import ContentReference from './Detail/components/ContentReference';
import { DTB } from 'views/App/Portal/DTB/_types/dtb';

export default function Library() {
  const { hasAppPermission } = useContext(AppContext);

  // const getDefaultRoute = () => {
  //   if (hasAppPermission('dtbManager')) {
  //     return (
  //       <Navigate
  //         to='.'
  //         replace
  //       />
  //     );
  //   } else {
  //     return (
  //       <Navigate
  //         to='/dashboard'
  //         replace
  //       />
  //     );
  //   }
  // };

  return (
    <Routes>
      <Route
        index
        element={<DTBList selectionMode />}
      />
      <Route
        path='new'
        element={<DTBCreate />}
      />
      <Route
        path=':id'
        element={
          <DTBLibraryProvider>
            <DTBDetail />
          </DTBLibraryProvider>
        }
      />
      <Route
        path=':id/content-reference'
        element={
          <DTBLibraryProvider>
            <ContentReference />
          </DTBLibraryProvider>
        }
      />
      <Route
        path='*'
        element={
          <Navigate
            to='/admin/dtbs/library'
            replace
          />
        }
      />
    </Routes>
  );
}
